import {atom} from "recoil";
import {FormSearchUpsellingRateModel, UpsellingRateCreation} from "../api/types/upsellingRate";
import {BASE_DEFINITION_FORM_STEPS} from "../constants";

export const initialUpsellingRateFilters: FormSearchUpsellingRateModel = {
    name: "",
    commercialCategoryId: null,
    commercialSegmentId: null,
    from: "",
    to: "",
    showOnlyActive: false,
    dealers: [],
    legalEntities: []
};
export const upsellingRateFiltersAtom = atom<FormSearchUpsellingRateModel>({
    key: "upsellingRateFiltersAtom",
    default: initialUpsellingRateFilters
});

export const initialUpsellingRateCreation: UpsellingRateCreation = {
    step: BASE_DEFINITION_FORM_STEPS.DEFINITION,
    readOnly: true,
    inUse: false,
    completed: [false, false, false]
};
export const upsellingRateCreationAtom = atom({
    key: "upsellingRateCreationAtom",
    default: initialUpsellingRateCreation
});
